export const formatBadgeText = (value: string): string => value.replace(', +', ' +');
